import {FETCH_CONTACTUS} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_CONTACTUS:
            return action.payload;
        default:
            return state;
    }
}